let Summary1990=[
    {"Countryname":" ",
    "OZ":0,
    "ME":227,
    "NU":122,
    "DI":173,
    "HR":145,
    "CO":132,
    "EC":55,
    "OT":0
    }]
export default Summary1990